const defaultNotification = {
    "title": "",
    "message": "",
    "level": "info",
    "position": "tr",
    "autoDismiss": 5,
    "dismissible": true,
    "action": null,
    "actionState": false
};

const NotificationLevel = {
    Notify: "notify",
    Success: "success",
    Info: "info",
    Warning: "warning",
    Error: "error"
};

class Notifier {
    constructor() {
        this.notificationSystem = null;
        this.Level = NotificationLevel;
    }

    initialize(notificationSystem) {
        this.notificationSystem = notificationSystem;
    }

    notify(notification) {
        let n = Object.assign({}, defaultNotification, notification);

        this.notificationSystem.addNotification(n);
    }
}

const notifier = new Notifier();

export default notifier;